import React, { FC } from 'react';
import { TypeEmptyDivFields } from '@/core/generated-types';

const EmptyDiv: FC<TypeEmptyDivFields> = ({ classes, divId }) => {
  if (!classes && !divId) return null;

  return <div className={classes} id={divId}></div>;
};

export default React.memo(EmptyDiv);
